import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_CATEGORY_OPTION, CONTENT_TYPE_EXTERNAL_LINK, CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT} from '../../constants';

export default {
  id: 'MOD_MAND_COLL',
  title: 'Comment activer le service d’aide à la collecte de mes documents ?',
  description: '',
  categories: [CONTENT_CATEGORY_OPTION],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Grâce à ce service*, nos équipes collectent, à votre place, vos documents administratifs auprès des organismes et des administrations, afin de les mettre à jour dans votre dossier et avant qu’ils arrivent en fin de validité.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Simplifiez votre quotidien en oubliant cette contrainte administrative et garantissez, sans effort, à l’ensemble de vos clients un dossier toujours à jour.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Comment le mettre en place ?'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Téléchargez le document'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}fr/FR_MOD_MAND_COLL/Mandat de Collecte.pdf`,
    label: 'en cliquant ici'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Renvoyez le document complété et signé à'
  },
  {
    type: CONTENT_TYPE_EXTERNAL_LINK,
    label: 'service.clients@onceforall.com',
    value: 'mailto:service.clients@onceforall.com'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: ' ',
    value: '\n'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: ' ',
    value: '*option disponible pour l’ensemble des offres à l’exception de l’offre Expérience.'
  }]
};
